import {LocalizationType} from '../types/LocalizationType';

export const MessagesEn: LocalizationType = {
    appTitle: 'Weather app',
    appTitlePre: 'Another',
    appSubTitle: 'React w/TypeScript',
    enterCityName: 'Enter city name',
    search: 'Search',
    noCurrentWeatherDataForCity: 'Cannot load current weather data for this city.',
    noHourlyWeatherDataForCity: 'Cannot load hourly weather data for this city.',
    humidity: 'Humidity',
    visibility: 'Visibility',
    feelsLike: 'Feels like',
    wind: 'Wind',
    kmph: 'km/h',
};